import {
  DbotEventDispatcher,
  DecisionContext,
  DecisionTypeHandler,
} from "@/dbot/common/commonDomain";
import { AssignsNewCompanyBoard, AssignsNewCompanyBoardForm } from "./assignsNewCompanyBoardDomain";
import { DecisionType } from "@/common/decisions";

export function initNewForm(
  dispatch: DbotEventDispatcher,
  context: DecisionContext<AssignsNewCompanyBoard>,
  data?: AssignsNewCompanyBoard,
): AssignsNewCompanyBoardForm {
  return new AssignsNewCompanyBoardForm(dispatch, context, data);
}

export function isValid(form: AssignsNewCompanyBoardForm): boolean {
  return form.isValid;
}

export function validate(form: AssignsNewCompanyBoardForm): boolean {
  return form.validate();
}

export function applyForm(form: AssignsNewCompanyBoardForm): AssignsNewCompanyBoard {
  const chairperson =
    form.selectedChairperson.value?.id &&
    (form.newBoardMembers.isSelected(form.selectedChairperson.value.id) ||
      form.newBoardMembersByName.isSelected(form.selectedChairperson.value.id))
      ? form.selectedChairperson.value
      : undefined;
  return {
    type: DecisionType.assignsNewCompanyBoard,
    members: form.newBoardMembers.value
      .filter((s) => s.isSelected)
      .map((s) => ({
        id: s.id,
        name: s.name,
      })),
    membersByName: form.newBoardMembersByName.value
      .filter((s) => s.isSelected)
      .map((s) => ({ id: s.id, name: s.name })),
    selectChairperson: form.selectChairPerson.value,
    chairperson,
    selectDeputyChairperson: form.selectDeputyChairperson.value,
    deputyChairperson:
      form.selectedDeputyChairperson.value?.id &&
      (form.newBoardMembers.isSelected(form.selectedDeputyChairperson.value.id) ||
        form.newBoardMembersByName.isSelected(form.selectedDeputyChairperson.value.id)) &&
      form.selectedChairperson.value?.id !== form.selectedDeputyChairperson.value.id
        ? form.selectedDeputyChairperson.value
        : undefined,
    deputy: form.newDeputyBoardMembers.value
      .filter((s) => s.isSelected)
      .map((m) => ({
        id: m.id,
        name: m.name,
        isSelected: m.isSelected,
        isPersonal: m.isPersonal,
        personalDeputyFor: m.isPersonal
          ? m.personalDeputyFor?.filter(
              (d) =>
                d.id &&
                (form.newBoardMembers.isSelected(d.id) ||
                  form.newBoardMembersByName.isSelected(d.id)),
            )
          : [],
      })),
    deputyByName: form.newDeputyBoardMembersByName.value
      .filter((s) => s.isSelected)
      .map((m) => ({
        id: m.id,
        name: m.name,
        isSelected: m.isSelected,
        isPersonal: m.isPersonal,
        personalDeputyFor: m.isPersonal
          ? m.personalDeputyFor?.filter(
              (d) =>
                d.id &&
                (form.newBoardMembers.isSelected(d.id) ||
                  form.newBoardMembersByName.isSelected(d.id)),
            )
          : [],
      })),
    boardMeetingProtocolShowCompanyBoard: form.boardMeetingProtocolShowCompanyBoard.value ?? false,
    noticeGeneralMeetingShowCompanyBoard: form.noticeGeneralMeetingShowCompanyBoard.value ?? false,
    genderCompositionRequirement: form.genderCompositionRequirement.value ?? undefined,
  };
}

export const assignsNewCompanyBoardHandler: DecisionTypeHandler<
  DecisionType.assignsNewCompanyBoard,
  AssignsNewCompanyBoard,
  AssignsNewCompanyBoardForm
> = {
  type: DecisionType.assignsNewCompanyBoard,
  initNewForm,
  isValid,
  validate,
  applyForm,
};
